// extracted by css-extract-rspack-plugin
export default {"toggle":"BQl9yFmF2E4qNkLB"};